import { Grid, makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import withPrivilege from "common/hocs/withPrivilege";
import { useEffect, useState } from "react";
import { colors } from "theme/colors";
import { EntityMap } from "util/roleUtils";
import "../styles.css";
import { getDetailsById } from "components/listOfValues/utils";
import { useParams } from "react-router-dom";
import PlanDetailsPage from "./PlanDetailsPage";
import AnnualPlanHeader from "./AnnualPlanHeader";
import AnnualPlanDetailCard from "./AnnualPlanDetailCard";
import { AnnualPlanInitialState } from "state/globalForms/initialStates";
import BreadCrumb from "../BreadCrumb";
import AnnualPlanCard from "./AnnualPlanCard";

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    flexWrap: "nowrap",
  },
  filterSection: {
    background: "white",
  },
  planSection: {
    height: "100%",
    minHeight: "100vh",
    width: "100%",
    padding: "47px 51px",
    backgroundColor: colors.gray5,
    [theme.breakpoints.down("sm")]: {
      padding: "36px",
    },
  },
  annualPlanCard: {
    marginBottom: "30px",
  },
}));

function AnnualPlanDetails(props) {
  const classes = useStyles();
  const theme = useTheme();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down("sm"));

  const [modalState, setModalState] = useState({
    isOpen: false,
    data: null,
    isEdit: false,
  });
  const [state, setState] = useState(AnnualPlanInitialState);
  const { id } = useParams();
  
  useEffect(() => {
    getPlanDetails();
  }, []);

  const getPlanDetails = async () => {
    const response = await getDetailsById("/annual-plans", id);
    setState(response || null);
  };

  return (
    <Grid container direction="row" className={classes.gridContainer}>
      {!isSmallDevice && (
        <Grid className={classes.filterSection} md="3">
          <BreadCrumb
            planId={id}
            planName={"ANNUAL_PLAN_DETAILS"}
            parentPath="annual-plans"
          />
          <AnnualPlanDetailCard
            data={state}
            {...props}
            getPlanDetails={getPlanDetails}
          />
        </Grid>
      )}
      <Grid className={classes.planSection} md="9" xs="12">
        {isSmallDevice && (
          <BreadCrumb
            planId={id}
            planName={"ANNUAL_PLAN_DETAILS"}
            parentPath="annual-plans"
          />
        )}
        <AnnualPlanHeader
          setModalState={setModalState}
          parentState={state}
          getPlanDetails={getPlanDetails}
          isSmallDevice={isSmallDevice}
          {...props}
        />
        {isSmallDevice && (
          <Grid item className={classes.annualPlanCard} xs="12">
            <AnnualPlanCard data={state} isDetailedPage={true} />
          </Grid>
        )}
        <PlanDetailsPage
          {...props}
          modalState={modalState}
          setModalState={setModalState}
          parentState={state}
          getPlanDetails={getPlanDetails}
        />
      </Grid>
    </Grid>
  );
}

export default withPrivilege(AnnualPlanDetails, EntityMap.annualplan);
